// Vendor imports
const classNames = require('classnames')
const React = require('react')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const SearchForm = require('client-v2/common/containers/search-form/component-smart')
const tag = require('client-v2/common/utils/hyperscript')

const bem = BemEntity('AppSidebarSearchModal')

function AppSidebarSearchModal({ className, onSearchDismiss }) {
  const handleSearchModalDismiss = React.useCallback(
    event => {
      // Ignore events that happen on child nodes
      if (event.target === event.currentTarget) {
        onSearchDismiss()
      }
    },
    [ onSearchDismiss ]
  )
  return (
    tag('div', {
      className: classNames(
        className,
        bem.block()
      ),
      onClick: handleSearchModalDismiss
    },
      tag(SearchForm, {
        className: bem.element('search-form')
      })
    )
  )
}

module.exports = AppSidebarSearchModal
